import { addClass, hasClass, replaceClass } from 'common/tools/dom/classes';
import { onYScroll } from 'common/tools/dom/on-scroll';
import { requestAnimationFrame } from 'common/tools/functions/request-animation-frame';

const timeToFade = 1000;

function addFadein(wrapper, video) {
  if (hasClass(wrapper, 'fade-out')) {
    replaceClass(wrapper, 'fade-out', 'fade-in');
  } else {
    addClass(wrapper, 'fade-in');
  }
  video.currentTime = 0;
  video.play();
}

function addFadeout(wrapper) {
  if (hasClass(wrapper, 'fade-in')) {
    replaceClass(wrapper, 'fade-in', 'fade-out');
  }
}

// function that allows to make the video visible or not
function updateAnimatedMoviePoster(currentScrollY, wrapper, video) {
  const posterOffsetTop = getElementOffsetTop(wrapper);
  const isVisible = currentScrollY <= posterOffsetTop;
  // if i'm in the visible zone
  if (isVisible) {
    addFadein(wrapper, video);
  } else {
    addFadeout(wrapper);
  }
}

// calc the visible zone
function getElementOffsetTop(el) {
  const boundingClientRect = el.getBoundingClientRect();
  const bodyEl = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || bodyEl.scrollTop;
  const clientTop = docEl.clientTop || bodyEl.clientTop || 0;
  return Math.round(boundingClientRect.top + scrollTop - clientTop);
}

// Default function that allows to start or not the video
export default function initAnimatedPoster() {
  const wrapper = document.getElementById('animated-poster');
  const video = document.getElementById('animated-poster-video');

  if (!video || !wrapper) {
    return false;
  }

  // if my video ends, i want it to play after a defined time
  video.addEventListener('ended', () => {
    addFadeout(wrapper);
    setTimeout(() => {
      addFadein(wrapper, video);
    }, timeToFade);
  });

  // if my video is visible after scrolling, i want it to play
  onYScroll(currentScrollY => {
    updateAnimatedMoviePoster(currentScrollY, wrapper, video);
  });

  // if my video is visible without scrolling, i want it to play
  requestAnimationFrame(() => {
    const currentScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop;
    updateAnimatedMoviePoster(currentScrollY, wrapper, video);
  });
}
